import { render, staticRenderFns } from "./QuickAction.vue?vue&type=template&id=4e2783a0&scoped=true&lang=pug"
import script from "./QuickAction.vue?vue&type=script&lang=ts"
export * from "./QuickAction.vue?vue&type=script&lang=ts"
import style0 from "./QuickAction.vue?vue&type=style&index=0&id=4e2783a0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2783a0",
  null
  
)

export default component.exports